import React, { Component } from 'react';
import {LoadGoogleAnalyticsScript} from '../../../core/utils/GoogleAnalyticTag';

class APGoogleBodyScript extends Component {
    render() {
        let googleAnalyticsScript = LoadGoogleAnalyticsScript('body');
        return( <iframe src={"data:text/html,"+encodeURIComponent(googleAnalyticsScript)} height="0" width="0" style={{display:'none',visibility:'hidden'}} title="googleBodyScript"/>);
    }
}

export default APGoogleBodyScript;
